import { css } from 'styled-components';
import { FontLineHeightNormal } from 'autogen/design-tokens/global/tokens';
import type { IBody } from '../components/Body';

const BodyStyling = css<{ $strong: IBody['strong'] }>`
     line-height: ${FontLineHeightNormal};
     font-family: ${({ theme }) => theme.TypographyFamilyPrimary};
     font-weight: ${({ $strong, theme }) => ($strong ? theme.TypographyBodyWeightStrong : theme.TypographyBodyWeightDefault)};
`;

export default BodyStyling;
